import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import getSelectedElements from './getSelectedElements';
import ElementPadding from '../../../../componentLibrary/ElementPadding';
import paddingChange from '../../paddingChange';
import * as columnItemActions from '../../../../actions/columnItem';
import { blockType } from '../../../../types';
import elementTypes from '../../../../constants/elementTypes';

// return the first valid element index, valid being an element that
// contains all the information we use for multiple elements settings
// in this case, spacer is the only one that does not have padding info
const getFirstValidElmForMultipleSettingsIdx = (elements) => {
    const elementIndexes = Object.keys(elements);

    let validElmIdx;
    for (let i = 0; i < elementIndexes.length; i++) {
        if (elements[elementIndexes[i]].type !== elementTypes.SPACER) {
            validElmIdx = elementIndexes[i];
            break;
        }
    }

    return validElmIdx;
};

class PaddingSettings extends PureComponent {
    state = {
        selectedElements: undefined,
        content: null,
        elements: [],
        hasPadding: false,
        contentValues: {
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
        },
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { canvasBlocks, selectedElements } = nextProps;
        const elmIdx = getFirstValidElmForMultipleSettingsIdx(selectedElements.local);
        if (!elmIdx) {
            return { ...prevState, hasPadding: false };
        }

        const { blockIndex, columnIdx } = selectedElements.local[elmIdx];
        const validElementData = canvasBlocks
            .find((block) => block.index === blockIndex)
            .content.columns.find((column) => column.columnIdx === columnIdx)
            .columnItems.find((elm) => elm.elmIdx === elmIdx);

        const { content } = validElementData;
        const { paddingTop, paddingRight, paddingBottom, paddingLeft } = content;

        let newElements = prevState.elements;
        if (prevState.selectedElements !== selectedElements) {
            newElements = getSelectedElements(selectedElements.local);
        }

        const contentValues = {
            paddingTop,
            paddingLeft,
            paddingRight,
            paddingBottom,
        };
        return {
            ...prevState,
            contentValues,
            elements: newElements,
            hasPadding: true,
        };
    }

    _updateContentInAlBlocks(key, value) {
        const { dispatch } = this.props;
        const { elements, contentValues } = this.state;
        const property = { key, value };
        let newContentValues;
        if (key === 'updateAllPadding') {
            const { paddingLeft, paddingRight, paddingBottom, paddingTop } = contentValues;
            const clampValue = value > 0 ? 50 : 0;
            const paddingValues = [paddingLeft, paddingRight, paddingBottom, paddingTop].map((pad) => {
                if (clampValue === 0) {
                    return pad + value < clampValue ? clampValue : pad + value;
                }
                return pad + value > clampValue ? clampValue : pad + value;
            });
            newContentValues = {
                ...contentValues,
                paddingLeft: paddingValues[0],
                paddingRight: paddingValues[1],
                paddingTop: paddingValues[2],
                paddingBottom: paddingValues[3],
            };
            const padTypes = Object.keys(contentValues);
            padTypes.forEach((type) => {
                const newProperty = {
                    key: type,
                    value: newContentValues[type],
                };
                dispatch(
                    columnItemActions.updateColumnItemContentInMultipleBlocks({
                        elements,
                        property: newProperty,
                    })
                );
            });
        } else {
            newContentValues = { ...contentValues, [key]: value };
            dispatch(
                columnItemActions.updateColumnItemContentInMultipleBlocks({
                    elements,
                    property,
                })
            );
        }
        this.setState((prevState) => ({
            ...prevState,
            contentValues: newContentValues,
        }));
    }

    render() {
        const { contentValues, hasPadding } = this.state;
        const { paddingTop, paddingLeft, paddingRight, paddingBottom } = contentValues;

        return (
            <React.Fragment>
                {hasPadding && (
                    <ElementPadding
                        paddingTop={paddingTop}
                        paddingBottom={paddingBottom}
                        paddingLeft={paddingLeft}
                        paddingRight={paddingRight}
                        elementType="multiple element"
                        onChange={(event) => {
                            const payload = paddingChange({
                                event,
                                paddingBottom,
                                paddingLeft,
                                paddingRight,
                                paddingTop,
                            });
                            if (!payload) {
                                return;
                            }
                            const { key, value = 0 } = payload;
                            this._updateContentInAlBlocks(key, value);
                        }}
                    />
                )}
            </React.Fragment>
        );
    }
}

PaddingSettings.propTypes = {
    dispatch: PropTypes.func.isRequired,
    canvasBlocks: PropTypes.arrayOf(blockType).isRequired,
    selectedElements: PropTypes.shape({
        local: PropTypes.object,
        remote: PropTypes.object,
    }).isRequired,
};

export default connect()(PaddingSettings);
